import 'jquery';
import 'Bem/site/form/form';
import 'Bem/site/ajax-form/ajax-form';
import { speed } from 'Lib/speed/speed';
import { onScreen } from 'Lib/on-screen/on-screen';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/checkbox-accept/checkbox-accept';
import 'Bem/site/img-loader/img-loader';
import 'Bem/site/tabs/tabs';
import 'Lib/auth/auth';
import 'Bem/site/auth-form/auth-form';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Vendor/fancybox/jquery.fancybox.min';
import { Popup } from 'Lib/popup/popup';
import { showAuth } from 'Lib/show-auth/show-auth';
import 'Vendor/owlcarousel/owl.carousel.min';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { PopupVideo } from 'Lib/popup/popup-video';
import 'Lib/on-width-resize/on-width-resize';

const $body = $('body');
const cSliderOn = 'owl-carousel';
// Голосование в видео
const $likeDislike = $('.litmost__screen2-video-btn_like-dislike-box');
const $likeDislikeBtnLike = $likeDislike.find('.litmost__screen2-video-btn-like-dislike_like');
const $likeDislikeBtnDislike = $likeDislike.find('.litmost__screen2-video-btn-like-dislike_dislike');
const $likeDislikeBtnLikeNum = $likeDislikeBtnLike.find('.like-dislike__num');
const $likeDislikeBtnDislikeNum = $likeDislikeBtnDislike.find('.like-dislike__num');
const cActive = 'js-active';
const type = $likeDislike.attr('data-type');
const id = $likeDislike.attr('data-id');
//
// Попапы
const elAboutBtn = document?.querySelector('.litmost__screen5-about-partners-btn');
const elProgramBtn = document?.querySelectorAll('.litmost__screen4-program-btn');
const popupAbout = new Popup('popup', document?.querySelector('.litmost__screen5-popup-about'));
const elBtnFormQuestion = document?.querySelectorAll('.litmost__btn-form-question');
const popupFormQuestion = new Popup('popup', document?.querySelector('.litmost__form-question'));
const popupVideo = new PopupVideo();

popupVideo.popupVideoOpenDefault();
//

// Меню
function toogleMenu() {
    document?.querySelector('.litmost__screen1').classList.toggle('litmost__screen1-right_active');
}

function fixedMenu() {
    $('.litmost__screen1').toggleClass('litmost__screen1-header-fixed', ($(window).scrollTop() > 72));
}
//

// Голосование в видео
function loadLikeDislike() {
    const date = new Date();

    $.ajax({
        type: 'GET',
        url: '/litmost/vote/vote.json',
        data: { unixTime: date.getTime() },
        cache: false,
        success(data) {
            $likeDislikeBtnLikeNum.text(data?.true);
            $likeDislikeBtnDislikeNum.text(data?.false);
        },
    });
}

function setSliderVideo() {
    if (getW() > eksmoBP.mdMin) {
        $('.litmost__screen7-content')
            .trigger('destroy.owl.carousel')
            .removeClass(cSliderOn)
            .addClass(cSliderOn)
            .owlCarousel({
                smartSpeed: speed * 2,
                margin: 24,
                nav: true,
                items: 1,
                dots: true,
                sArrows: '.litmost__arrows',
                navClass: ['litmost__prev arrow arrow_prev arrow_shadow', 'litmost__next arrow arrow_next arrow_shadow'],
                navText: ['', ''],
            });
    } else {
        $('.litmost__screen7-content').trigger('destroy.owl.carousel').removeClass(cSliderOn);
    }
}

setSliderVideo();
$body.on('eksmoResizeWidth', setSliderVideo);
$('html').toggleClass('is-authorized', (!$('.cheader__item_auth .js-link-auth-forms').length));
loadLikeDislike();

$body.on('eksmoPagenavAjax', () => {
    popupVideo.popupVideoOpenDefault();
});

setInterval(() => {
    loadLikeDislike();
}, 10000);

$likeDislike.on('click', '.litmost__screen2-video-btn-like-dislike_like, .litmost__screen2-video-btn-like-dislike_dislike', function () {
    const $th = $(this);
    let statusLike = '';

    if (!$('html').hasClass('is-authorized')) {
        showAuth();
    } else {
        statusLike = !!$th.hasClass('litmost__screen2-video-btn-like-dislike_like');

        $.ajax({
            type: 'GET',
            url: `/litmost/vote.php?guid=${id}&type=${type}&value=${statusLike}`,
            cache: false,
            dataType: 'json',
            success(data) {
                $likeDislike.find('.litmost__screen2-video-btn-like-dislike').removeClass(cActive);

                if (statusLike) {
                    $likeDislikeBtnLike.addClass(cActive);
                } else {
                    $likeDislikeBtnDislike.addClass(cActive);
                }

                $likeDislikeBtnLikeNum.text(data?.true);
                $likeDislikeBtnDislikeNum.text(data?.false);
            },
        });
    }
});

onScreen($('.litmost__section'), ($el) => {
    $el.addClass('litmost__section_visible');
}, 200, 200, 1.6);
//

// Меню
fixedMenu();
$(window).on('scroll', fixedMenu);

document?.querySelector('.litmost__screen1-btn-menu-box').addEventListener('click', () => {
    toogleMenu();
});

document?.querySelector('.litmost__screen1-btn-menu-close-box').addEventListener('click', () => {
    toogleMenu();
});

document?.querySelectorAll('.litmost__screen1-nav-item').forEach((item) => {
    item.addEventListener('click', () => {
        toogleMenu();
    });
});
//

// Попапы
elAboutBtn?.addEventListener('click', () => {
    popupAbout.open();
});

elProgramBtn?.forEach((item) => {
    const popupProgram = new Popup('popup', item?.closest('.litmost__screen4-program-item').querySelector('.litmost__screen5-popup-form'));

    item.addEventListener('click', () => {
        popupProgram.open();
    });
});

elBtnFormQuestion.forEach((item) => {
    item.addEventListener('click', () => {
        popupFormQuestion.open();
    });
});
//

svgSpriteLoader('/landing/litmost/svg/sprite.svg?v=20180320');